import React from 'react';

import moment from 'moment';
import '../scss/ResultadoDetailTiempo.css';
import {formatMs, msFullAhora} from '../utils/time';

const ResultadoDetailTiempo = (props) => {
  const {guntime, resultado, prevision, competicion} = props
  const fechaInicio = moment(props.fechaInicio)
  // @todo: de momento fecha de fin == fecha de inicio + 2 dia
  let fechaFin = moment(fechaInicio)
  fechaFin.add(2, 'days')
  // console.info(fechaInicio.format(), fechaInicio.isBefore(moment()), fechaFin.isAfter(moment()))

  // console.info(props.fechaInicio)
  let tiempoAhora = msFullAhora(props.fechaInicio) - guntime
  // console.info(resultado.start)
  // console.info(formatMs(resultado.guntime))
  if (resultado.guntime) {
    tiempoAhora = msFullAhora(props.fechaInicio) - resultado.guntime
  }
  // console.info(competicion)
  if (resultado.start && competicion.tipo === 'TIEMPONETO') {
    tiempoAhora = msFullAhora(props.fechaInicio) - resultado.start
  }

  // console.info(formatMs(tiempoAhora))
  // console.info(fechaInicio.format(), moment().format(), (fechaInicio.isBefore(moment()) && fechaFin.isAfter(moment())))
  return <div>
    {resultado.descalificado ? (
      <div className={'resultado__tiempo resultado__tiempo--descalificado'}>
        DESCALIFICADO
      </div>
    ) : (
      <div>
        {resultado.tiempo ? (
          <div>
            <div className={'resultado__tiempo'}>
              {/* El participante ha llegado a meta */}
              <div className={'resultado__tiempo-label'}>
                CARRERA FINALIZADA
              </div>
              {formatMs(resultado[ 'tiempo' ])}
            </div>
            <div><br /></div>
          </div>
        ) : (
          <div>
            {(fechaInicio.isBefore(moment()) && fechaFin.isAfter(moment())) &&
            <div>
              {(guntime > 0) && (
                <div className={'resultado__tiempo'}>
                  {/* El participante está en carrera (comprobar guntime pasado) */}
                  <div className={'resultado__tiempo-label'}>
                    TIEMPO EN CARRERA
                  </div>
                  {formatMs(tiempoAhora)}
                </div>
              )}
              {(prevision && prevision.tiempo && tiempoAhora > 0) ? (
                <div>
                  <div>
                    <div className={'resultado-detail__prevision'}>
                      <label className={'resultado-detail__prevision-label'}>
                        DISTANCIA RECORRIDA
                      </label>
                      {((prevision.distancia + prevision.inicioDistancia) / 1000).toFixed(1)} km
                    </div>
                    <div className={'resultado-detail__recorrido'}>
                      <label className={'resultado-detail__recorrido-label'}>
                        PREVISIÓN EN {prevision.control.nombre}
                      </label>
                      {formatMs(prevision.tiempoTotal)}
                    </div>
                  </div>
                  <div className={'resultado-detail__progreso'}>
                    <div className={'resultado-detail__progreso-barra'}>
                      <div className={'resultado-detail__progreso-completado'} style={{ width: prevision.porcentaje + '%' }} />
                    </div>
                  </div>
                </div>
              ) : (
                <div><br /></div>
              )}
            </div>
            }
          </div>
        )}
      </div>
    )}
  </div>
}

export default ResultadoDetailTiempo



// WEBPACK FOOTER //
// ./src/components/ResultadoDetailTiempo.js